/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export default {
    init() {
    


      //===============================
      //  Highlight current day on
      //  branch opening hours
      //===============================
      if(document.querySelector('.showroom-details__opening-hours')){
        const days = document.querySelectorAll('.showroom-opening-time');
        const now = new Date;
        const today = now.getUTCDay();
        
        //Ensure full is added before calculating
        if(days.length === 7){
          days[today-1].classList.add('today');
        }
      }

      //NOTE: This needs to be a global function for Google maps to be able to use as a callback
      window.initMap = function(){
        var $el = $('#showroom-map');
        var wrapper = $('.showroom-map-wrap')
        var $markers = wrapper.find('.marker');// Find marker elements within map.

        // Create gerenic map.
        var mapArgs = {
          zoom        : $el.data('zoom') || 12,
          mapTypeId   : google.maps.MapTypeId.ROADMAP,
          disableDefaultUI: true, // disable the default User Interface
          zoomControl: true, // add back fullscreen, streetview, zoom
          streetViewControl: true,
          fullscreenControl: false,
          styles       : [
            {
              'featureType': 'water',
              'elementType': 'geometry.fill',
              'stylers': [ { 'color': '#d3d3d3' } ],
            },
            {
              'featureType': 'transit',
              'stylers': [
                { 'color': '#808080' },
                { 'visibility': 'off' },
              ],
            },
            {
              'featureType': 'road.highway',
              'elementType': 'geometry.stroke',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#b3b3b3' },
              ],
            },
            {
              'featureType': 'road.highway',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#ffffff' } ], 
            },
            {
              'featureType': 'road.local',
              'elementType': 'geometry.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#ffffff' },
                { 'weight': 1.8 },
              ],
            },
            {
              'featureType': 'road.local',
              'elementType': 'geometry.stroke',
              'stylers': [{ 'color': '#d7d7d7' }],
            },
            {
              'featureType': 'poi',
              'elementType': 'geometry.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#ebebeb' },
              ],
            },
            {
              'featureType': 'administrative',
              'elementType': 'geometry',
              'stylers': [{ 'color': '#a7a7a7' }],
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#ffffff' }],
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#ffffff' }],
            },
            {
              'featureType': 'landscape',
              'elementType': 'geometry.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#efefef' },
              ],
            },
            {
              'featureType': 'road',
              'elementType': 'labels.text.fill',
              'stylers': [{ 'color': '#696969' }],
            },
            {
              'featureType': 'administrative',
              'elementType': 'labels.text.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#737373' },
              ],
            },
            {
              'featureType': 'poi',
              'elementType': 'labels.icon',
              'stylers': [{ 'visibility': 'off' } ],
            },
            {
              'featureType': 'poi',
              'elementType': 'labels',
              'stylers': [{ 'visibility': 'off' }],
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.stroke',
              'stylers': [{ 'color': '#d6d6d6' }],
            },
            {
              'featureType': 'road',
              'elementType': 'labels.icon',
              'stylers': [{ 'visibility': 'off' }],
            },
            {},
            {
              'featureType': 'poi',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#dadada' }],
            },
          ],
        };

        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
          initMarker( $(this), map );
        });

        centerMap( map );// Center map based on markers.
        return map;// Return map instance.
      }

      function initMarker( $marker, map ) {
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var branch = $marker.data('title');
        var latLng = {
          lat: parseFloat( lat ),
          lng: parseFloat( lng ),
        };

        // Create custom marker
        const svgMarker = {
          path: 'M25.106,3A17.593,17.593,0,0,0,7.5,20.606c0,13.2,17.606,32.7,17.606,32.7s17.606-19.492,17.606-32.7A17.593,17.593,0,0,0,25.106,3Z',
          fillColor: '#da291c',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(0, 50),
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
          position : latLng,
          map: map,
          title: branch,
          icon: svgMarker,
          animation: google.maps.Animation.DROP,
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        // if( $marker.html() ){
        //   // Create info window.
        //   var infowindow = new google.maps.InfoWindow({
        //     content: $marker.html(),
        //   });

        //   // Show marker on load then remove listener
        //   var loadListener = google.maps.event.addListener(map, 'idle', function() {
        //     infowindow.open( map, marker );
        //     google.maps.event.removeListener(loadListener);
        //   });

        //   // Show info window when marker is clicked.
        //   google.maps.event.addListener(marker, 'click', function() {
        //     infowindow.open( map, marker );
        //   });
        // }
      }

      function centerMap( map ) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
          bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          });
        });

        if( map.markers.length == 1 ){ map.setCenter( bounds.getCenter() ) }        // Case: Single marker.
        if( map.markers.length != 1){ map.fitBounds( bounds ); }                    // Case: Multiple markers.
      }
     
     
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS

      //add script after page is loaded - this will use the code in the init() object as a callback
      if(document.querySelector('#showroom-map')){
        var el = document.createElement('script');
        el.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBpMNVqH69ckOFYSnqUovDA2pZqyXZhb1w&v=weekly&callback=initMap';
        el.setAttribute('defer', true);
        el.setAttribute('async', true);
        var body = document.getElementsByTagName('body')[0];
        body.append(el);
      }
        
    },
  };
  